import dayjs from "dayjs";

import type { IPackagesPrice } from "../types";
import { usePackagePurchase } from "../usePackagePurchase";

import { TRIAL_EXTENSION_DAYS } from "./constants";

export const useStepPackages = (packages: IPackagesPrice | null) => {
    const { currentCurrency, onSubmitStep } = usePackagePurchase(packages);
    const dueDate = dayjs().add(TRIAL_EXTENSION_DAYS, "days");

    return {
        currentCurrency,
        dueDate,
        onSubmitStep,
    };
};
